import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Minimal theme switch.
 * - Dark mode active  -> shows a white swatch (click = switch to light).
 * - Light mode active -> shows a navy-black swatch (click = switch to dark).
 * Colors are inline so they stay inverted regardless of the active theme.
 */
const ThemeToggle = ({ className = '' }) => {
  const { isLight, toggleTheme } = useTheme();

  const style = isLight
    ? { background: '#111318', color: '#e2e8f0', boxShadow: '0 1px 2px rgba(15,23,42,0.15)' }
    : { background: '#ffffff', color: '#1e293b', boxShadow: '0 1px 2px rgba(0,0,0,0.25)' };

  return (
    <button
      type="button"
      onClick={toggleTheme}
      style={style}
      title={isLight ? 'Koyu temaya geç' : 'Açık temaya geç'}
      aria-label={isLight ? 'Koyu temaya geç' : 'Açık temaya geç'}
      className={`group inline-flex h-9 w-9 items-center justify-center rounded-full transition-all duration-200 hover:scale-105 ${className}`}
    >
      {isLight ? (
        <Moon className="h-4 w-4 transition-transform duration-200 group-hover:-rotate-12" />
      ) : (
        <Sun className="h-4 w-4 transition-transform duration-200 group-hover:rotate-45" />
      )}
    </button>
  );
};

export default ThemeToggle;
